import {createSelector} from '@reduxjs/toolkit';
import {getExtras} from '../../data';
import {getIsExtrasFeatureEnabled} from '../../infrastructure';
import {RootState} from '../../rootReducer';

export const getAreExtraFlagsEnabled = createSelector(
  getIsExtrasFeatureEnabled,
  (isExtrasFeatureEnabled) => isExtrasFeatureEnabled,
);

export const getExtrasBySpecificType = createSelector(
  getExtras,
  (_state: RootState, extraType: string) => extraType,
  (extras, extraType) => extras.filter((extra) => extra.type === extraType),
);
